import React from 'react';
import ReactMarkdown from 'react-markdown';
import {EnviosMD} from './Avisos';
import { useEffect } from 'react';
export const Envios = () => {
  //Scroll to top
  useEffect (() => {
    window.scrollTo(0, 0);
  }
  , []);
  return (
    <div
        style={{
            padding: '20px',
            maxWidth: '800px',
            margin: 'auto',
        }}
    >
        <ReactMarkdown>
            {EnviosMD}
        </ReactMarkdown>
    </div>
  );
};

export default Envios;
